import { dateFormats } from 'constants/common'
import { GHOST_WHITE } from 'constants/colors'
import { Button as CLButton } from 'component_library/1_Atoms'
import styles from './index.module.scss'
import { TimeZoneContext } from 'context/common/TimeZoneContext'
import { useContext } from 'react'

type EmptySlotsProps = {
  providerDetails: Provider
  nextAvailabilityDate: string | number
  changeDate: () => void
}

const EmptySlots: React.FC<EmptySlotsProps> = ({
  providerDetails,
  nextAvailabilityDate,
  changeDate,
}) => {
  const { format } = useContext(TimeZoneContext)

  return (
    <div
      className="flex-center flex-grow-1 align-self-stretch"
      style={{
        backgroundColor: !nextAvailabilityDate ? GHOST_WHITE : 'white',
      }}
    >
      {!!nextAvailabilityDate ? (
        <CLButton
          theme="v2"
          variant="tertiary"
          size="sm"
          aria-label="Select next available opening slot"
          onClick={changeDate}
          className={styles.next_opening_btn}
        >
          {`Next opening: ${format(
            nextAvailabilityDate,
            `${dateFormats.DAY_FORMAT} ${dateFormats.MONTH_DATE_SINGLEDIGIT_FORMAT}, ${dateFormats.TIME_FORMAT_LOWER}`
          ).replace(':00', '')}`}
        </CLButton>
      ) : (
        <p className="text-center fs-16 font-weight-medium">
          {`${providerDetails?.firstName} has no upcoming availability`}
        </p>
      )}
    </div>
  )
}

export default EmptySlots
